import { render, staticRenderFns } from "./TheChecklist.vue?vue&type=template&id=1b2b1d4c&scoped=true"
import script from "./TheChecklist.vue?vue&type=script&lang=js"
export * from "./TheChecklist.vue?vue&type=script&lang=js"
import style0 from "./TheChecklist.vue?vue&type=style&index=0&id=1b2b1d4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2b1d4c",
  null
  
)

export default component.exports